import { z } from "zod";
import { get } from "./api.ts";

async function getCsrfCookie(): Promise<string> {
  // 2. Token vom Server abholen → legt Cookie "XSRF-TOKEN"
  const resp = await get(
    `/csrf-token`,
    z.object({
      headerName: z.string(),
      token: z.string(),
    }),
  );
  return resp.token;
}

async function ensureCsrf() {
  try {
    await getCsrfCookie();
  } catch (e) {
    console.error("Konnte CSRF-Token nicht holen:", e);
  }
}

export { ensureCsrf };
